import { useLanguage } from '@/contexts/LanguageContext';
import { en, fr, ar } from '@/i18n/translations';

const translations = { en, fr, ar };

function useTranslation() {
  const { language } = useLanguage();

  const t = (key: string, params: { date?: string } = {}): string => {
    const keys = key.split('.');
    let value: any = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    if (typeof value !== 'string') {
      console.warn(`Translation key "${key}" not found for language "${language}"`);
      return key;
    }
    
    // Handle date parameter with proper localization
    if (params.date) {
      const dateObj = new Date(params.date);
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      
      const formattedDate = new Intl.DateTimeFormat(
        language === 'ar' ? 'ar-SA' : 
        language === 'fr' ? 'fr-FR' : 
        'en-US', 
        options
      ).format(dateObj);
      
      return value.replace('{{date}}', formattedDate);
    }
    
    return value;
  };

  return { t, language };
}

export default useTranslation; 